export const version = '5.1.5';
export const buildTime = 'Fri Oct 23 2026 11:47:04 GMT+0200 (Central European Summer Time)';
export const sourceUrl = 'https://github.com/UUDigitalHumanitieslab/gretel/tree/ee6ffb001617ae11e91d18b1ab4f799fa5d642cf';
